// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"515":"auth-layout","870":"pokemon"}[chunkId] + "." + {"515":"65155d56","870":"693a0b2c"}[chunkId] + ".css";
};